import Chatbot from '../../components/Chatbot/Chatbot';

const Saturn = () => {
    return <Chatbot/>;
};

export default Saturn;
